import styled from 'styled-components';
import { CarouselSkipLinkMixin } from '../../mixins/components/CarouselSkipLinkMixin';
import { Anchor } from '../Anchor/Anchor';
export var StyledCarouselSkipLink = /*#__PURE__*/styled(Anchor).withConfig({
  displayName: "StyledCarouselSkipLink",
  componentId: "c11n-8-107-0__sc-uh66ps-0"
})(["", ""], CarouselSkipLinkMixin);